import React from "react";
import Main from "../components/Main";
import SkillsAndCertifications from "../components/SkillsAndCertifications";
import Projects from "../components/Projects";

export default function Home() {
  return (
    <div>
      <Main />
      <SkillsAndCertifications />
      <Projects />
    </div>
  );
}
